(() => {
  // app/scripts/dropdown-component.js
  !window.customElements.get("dropdown-component") && window.customElements.define("dropdown-component", class extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    connectedCallback() {
      const contentHeight = this.contentBody.scrollHeight + "px";
      this.contentBody.style.setProperty("--height", contentHeight);
    }
    init() {
      this.headerTrigger = this.querySelector(".dropdown-component-trigger");
      this.contentBody = this.querySelector(".dropdown-component-content");
      this.headerTrigger.addEventListener("click", (event) => {
        if (this.contains(event.target)) {
          this.toggleAttribute("open");
        }
      });
      this.contentBody.addEventListener("click", (event) => {
        const clickedItem = event.target.closest("li");
        if (clickedItem) {
          const label = clickedItem.querySelector("label").textContent;
          const value = clickedItem.querySelector("input").value;
          this.querySelector(".js-filter-update").textContent = label;
          this.setAttribute("js-filter-update", value);
          this.removeAttribute("open");
        }
      });
      document.addEventListener("click", (event) => {
        if (!this.contains(event.target)) {
          this.removeAttribute("open");
        }
      });
    }
  });
})();
